// Where the ui layer teleports overlay content (tooltip now; dialog, popover,
// select later).
//
// Reka's default is <body>, and that is wrong here: the theme tokens are custom
// properties scoped to the `.association` / `.cooperative` class, which sits on
// `.appContainer` — below <body>. Content teleported to <body> keeps only the
// `:root` `--primary` (whichever theme partial was injected last) and loses
// `--sp`, `--dark-primary`, `--default-shadow` and the rest.
//
// So every overlay component injects its target from here, and a subtree that
// carries its own theme class (the gallery's two theme sections) provides
// itself instead.
export const UI_PORTAL_TARGET = Symbol('uiPortalTarget')

export const DEFAULT_UI_PORTAL_TARGET = '.appContainer'

// Spread into a component's `inject` option; exposes `this.uiPortalTarget`.
export const injectUiPortalTarget = {
  uiPortalTarget: { from: UI_PORTAL_TARGET, default: DEFAULT_UI_PORTAL_TARGET },
}
